//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    import { mapState } from 'vuex'
    import userChecks from '~/mixins/userChecks';
    import sort from '~/components/content/model/sort_model';
    import modelItem from '~/components/content/model/model.vue'
    import dummyItem from '~/components/content/dummy/model_dummy.vue'
    import banner from '~/components/banner.vue'

    export default {
        mixins: [userChecks],
        async fetch() {
            await Promise.all([ 
              this.$store.dispatch('pagesStore/getPage', 'modellen'),
              this.$store.dispatch('resourcesStore/getResources', this.queries.models),
              this.$store.dispatch('bannerStore/getBanner')
              ])
        },
        head() {
          return {
            title: this.pages.modellen ? this.pages.modellen.seo.title : 'Modellen | Sexy Mooie pornosterren | Secret Circle',
            meta: [
              { hid: 'title', name: 'title', content: this.pages.modellen ? this.pages.modellen.seo.title : 'Modellen | Sexy Mooie pornosterren | Secret Circle' },
              { hid: 'og:title', name: 'og:title', content: this.pages.modellen ? this.pages.modellen.seo.title : 'Modellen | Sexy Mooie pornosterren | Secret Circle' },
              { hid: 'description', name: 'description', content: this.pages.modellen ? this.pages.modellen.seo.description : 'Geile Hollandse amateur meiden en pornosterren spelen in de lekkerste seksfilms. Mooie vrouwen neuken voor jou in de lekkerste standjes'},
              { hid: 'og:description', name: 'og:description', content: this.pages.modellen ? this.pages.modellen.seo.description : 'Geile Hollandse amateur meiden en pornosterren spelen in de lekkerste seksfilms. Mooie vrouwen neuken voor jou in de lekkerste standjes' },
              { hid: 'og:url', name: 'og:url', content: process.env.FE_URL + '/modellen' },
              { hid: 'keywords', name: 'keywords', content: this.pages.modellen ? this.pages.modellen.seo.keywords : 'geile meiden, seks actrices, pornosterren, Hollandse meiden'},
              ]
        }
    },
    name: 'modelsCollection',
    components: {
        sort,
        modelItem,
        dummyItem,
        banner,
        Loadmore: () => import('~/components/loadmore.vue')
    },
    data() {
        return {
            end: false,
            getLoadMore: false,
            loadMoreButton: true,
            loadingFilter: false,
        }
    },
    computed: {
        ...mapState({
            pages: ({ pagesStore: {pages} }) => pages,
            queries: ({ resourcesStore: {queries} }) => queries,
            models: ({ resourcesStore: {models} }) => models,
            loading: ({ resourcesStore: {loading} }) => loading
        }),
    }
}
